import _ from "lodash";

const permissionToAction = {
  read: ["read"],
  manage: ["create", "update", "delete"],
};

export default {
  savePath: (state, payload) => {
    state.path = payload;
  },
  setUser: (state, payload) => {
    const abilities = {};
    payload.abilities.forEach((i) => {
      abilities[i.resource] = i.permissions.reduce(
        (acc, v) => acc.concat(permissionToAction[v]),
        []
      );
    });
    state.abilities = abilities;
    state.isTempPassword = payload.isTempPassword;
    state.fullName = payload.fullName;
    state.originalUser = payload.originalUser;

    // TODO IE-160-Default Path for Role - add default path for role
  },
  tempPasswordChanged: (state) => {
    state.isTempPassword = false;
  },
  showLoader: (state, withOverlay = true) => {
    state.loading = true;
    state.overlayInLoading = withOverlay;
  },
  hideLoader: (state) => {
    state.loading = false;
    state.overlayInLoading = false;
  },
  showDialog: (state, payload) => {
    state.modals.push(Object.assign({ id: _.uniqueId("modal") }, payload));
  },
  deleteDialog: (state, id) => {
    state.modals.splice(
      state.modals.findIndex((i) => i.id === id),
      1
    );
  },
  deleteAllDialogs: (state) => {
    state.modals = [];
  },
  resetAbilites: (state) => {
    state.abilities = null;
  },
  resetImpersonation: (state) => {
    state.originalUser = null;
  }
};
